import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/shared/Button/Button';
import { images } from '../../components/shared/assets';
import './NotFoundPage.css';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const handleHomepageClick = () => {
    navigate('/');
  };

  return (
    <div className="not-found-page">
      {/* Text Block + Button */}
      <div className="not-found-content">
        <h1 className="not-found-404">404</h1>
        <h2 className="not-found-message">Ooops, Page Not Found</h2>
        <Button 
          variant="outline" 
          size="medium"
          onClick={handleHomepageClick}
          className="not-found-button"
        >
          TAKE ME TO HOMEPAGE
        </Button>
      </div>

      {/* 3-Image Collage */}
      <div className="not-found-collage">
        <div 
          className="not-found-image not-found-image--bottom"
          style={{ backgroundImage: `url('${images.film13}')` }}
        />
        <div 
          className="not-found-image not-found-image--middle"
          style={{ backgroundImage: `url('${images.film14}')` }}
        />
        <div 
          className="not-found-image not-found-image--top"
          style={{ backgroundImage: `url('${images.film15}')` }}
        />
      </div>
    </div>
  );
};

export default NotFoundPage;